import localstory from "localstory";

const isClient = process.env.BUILD_TARGET === "client";
// This singleton will return an instance of local storage to be used across the application
const flightsLocalStore = isClient ? localstory(window.localStorage, "flights") : undefined;

export { flightsLocalStore };
